import React from 'react';
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import HeaderPages from '../../../component/page-components/pages-header';
import useUserEdit from './user-management/user-edit.hooks';
import UserProfile from './edit/user-profile';
import AccessSettings from './edit/access-settings';
import PrimaryButton from '../../../component/button/PrimaryButton';
import SecondaryButton from '../../../component/button/SecondaryButton';
import { t } from 'i18next';
import ModalSuccessUpdated from '../../../component/modal/ModalSuccessUpdated';
import NotifFailedSaved from '../../../component/modal/NotifFailedSaved';
import style from './userPage.module.css'

const UserEdit = () => {
  const {
    handleBack,
    onChangeTab,
    tab1,
    tab2,
    name,
    _onSave,
    _onChange,
    _onChangeSelect,
    form,
    listCountry,
    listProvince,
    District,
    SubDistrict,
    UrbanVillage,
    PostalCode,
    listRole,
    listDataGroup,
    Province,
    successModalOpen,
    failedModalOpen,
    _onOk,
    failedMessages,
    setFailedModalOpen,
    onChangeCountry,
    onChangeDistrict,
    onChangePostalCode,
    onChangeProvince,
    onChangeSubdistrict,
    onChangeUrbanvillage,
    onScrollCountry,
    onScrollDistrict,
    onScrollPostalCode,
    onScrollProvince,
    onScrollUrbanvillage,
    onScrollSubdistrict,
    loading,
    searchValue,
    error
  } = useUserEdit();

  return (
    <>
      <div className='p-5 h-fit'>
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Admin`}
          menuLevel2={`User Management`}
          menuLevel3={`User`}
          menuLevel4={`Edit ${name}`}
        />
        <HeaderPages
          title="Edit"
          withName
          name={name}
          menuType="edit"
          handleBack={handleBack}
        />
        <div className=' bg-white-100 p-5 rounded-[10px]'>
          <div className=' flex flex-row'>
            <p
              className={
                tab1 ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer` :
                  `text-gray-100 font-roboto text-2xl font-medium cursor-pointer`
              }
              onClick={() => onChangeTab(1)}
            >
              User Profile
            </p>
            <p
              className={
                tab2 ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer ml-5` :
                  `text-gray-100 font-roboto text-2xl font-medium ml-5 cursor-pointer`
              }
              onClick={() => onChangeTab(2)}
            >
              Access Setting
            </p>
          </div>
          {
            tab1 ? (
              <UserProfile _onChange={_onChange} _onChangeSelect={_onChangeSelect}
                form={form} listCountry={listCountry} Province={Province}
                District={District} SubDistrict={SubDistrict}
                UrbanVillage={UrbanVillage} PostalCode={PostalCode}
                style={style}
                onChangeCountry={onChangeCountry}
                onChangeDistrict={onChangeDistrict}
    onChangePostalCode={onChangePostalCode}
    onChangeProvince={onChangeProvince}
    onChangeSubdistrict={onChangeSubdistrict}
    onChangeUrbanvillage={onChangeUrbanvillage}
    onScrollCountry={onScrollCountry}
    onScrollDistrict={onScrollDistrict}
    onScrollPostalCode={onScrollPostalCode}
    onScrollProvince={onScrollProvince}
    onScrollUrbanvillage={onScrollUrbanvillage}
    onScrollSubdistrict={onScrollSubdistrict}
    loading={loading}
    searchValue={searchValue}
    error={error}
              />
            ) :
              tab2 ? (
                <AccessSettings
                  form={form}
                  listRole={listRole}
                  listDataGroup={listDataGroup}
                  _onChangeSelect={_onChangeSelect}
                  style={style}
                />
              ) : null
          }
        </div>
      </div>
      <div className='flex flex-row-reverse gap-[16px] px-5 mt-5 mb-10'>
        <PrimaryButton text={t("USER_DETAIL:SAVE")} action={_onSave} />
        <SecondaryButton text={t("USER_DETAIL:CANCEL")} action={handleBack} />
      </div>
      <ModalSuccessUpdated
        isVisible={successModalOpen}
        onOk={_onOk}
      />
      <NotifFailedSaved
        visible={failedModalOpen}
        message={failedMessages}
        action={() => { setFailedModalOpen(false) }}
      />
    </>
  );
}

export default UserEdit;